"use client";
import React, { useEffect, useRef } from "react";
import styles from "../../components/LandingPage/Favourites/Favourites.module.scss";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
export interface productProps {
	icon: string;
	name: string;
	variant: string;
	image: string;
	price: number;
	tag: string;
}

const useFavourites = () => {
	const productData: productProps[] = [
		{
			image: "/images/favourites_1.png",
			price: 5000,
			icon: "/svgs/star_11.svg",
			name: "Coca Cola",
			variant: "pack of 12",
			tag: "soft drink",
		},
		{
			image: "/images/favourites_2.png",
			price: 26400,
			icon: "/svgs/star_22.svg",
			name: "Monster",
			variant: "pack of 24",
			tag: "energy drink",
		},
		{
			image: "/images/favourites_3.png",
			price: 7200,
			icon: "/svgs/star_33.svg",
			name: "5 Alive Pulpy",
			variant: "pack of 12",
			tag: "juice",
		},
		{
			image: "/images/favourites_4.png",
			price: 6800,
			icon: "/svgs/star_44.svg",
			name: "1.5L Eva Water",
			variant: "pack of 12",
			tag: "water",
		},
	];

	const topSectionRef = useRef<HTMLDivElement>(null);
	const firstCardRef = useRef<HTMLDivElement>(null);
	const secondCardRef = useRef<HTMLDivElement>(null);
	const thirdCardRef = useRef<HTMLDivElement>(null);
	const fourthCardRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const isMobile = () => window.innerWidth <= 650;
		const topSection = topSectionRef.current;
		const firstCard = firstCardRef.current;
		const secondCard = secondCardRef.current;
		const thirdCard = thirdCardRef.current;
		const fourthCard = fourthCardRef.current;

		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(styles.visible);
						// observer.unobserve(entry.target);
					} else {
						entry.target.classList.remove(styles.visible);
					}
				});
			},
			{
				root: null,
				rootMargin: "0px",
				threshold: 0.15,
			}
		);

		const cardObserver = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(styles.visible);
						// cardObserver.unobserve(entry.target);
					} else {
						entry.target.classList.remove(styles.visible);
					}
				});
			},
			{
				root: null,
				threshold: 0.04,
				rootMargin: "0px",
			}
		);

		const setupObservers = () => {
			const mobile = isMobile();
			if (mobile) {
				if (topSection) observer.unobserve(topSection);
				if (firstCard) cardObserver.observe(firstCard);
				if (secondCard) cardObserver.observe(secondCard);
				if (thirdCard) cardObserver.observe(thirdCard);
				if (fourthCard) cardObserver.observe(fourthCard);
			} else {
				if (firstCard) cardObserver.unobserve(firstCard);
				if (secondCard) cardObserver.unobserve(secondCard);
				if (thirdCard) cardObserver.unobserve(thirdCard);
				if (fourthCard) cardObserver.observe(fourthCard);
				if (topSection) observer.observe(topSection);
			}
		};

		setupObservers();

		window.addEventListener("resize", setupObservers);

		return () => {
			window.removeEventListener("resize", setupObservers);
			if (isMobile()) {
				if (firstCard) cardObserver.unobserve(firstCard);
				if (secondCard) cardObserver.unobserve(secondCard);
				if (thirdCard) cardObserver.unobserve(thirdCard);
				if (fourthCard) cardObserver.unobserve(fourthCard);
				cardObserver.disconnect();
			} else {
				if (topSection) observer.unobserve(topSection);
				observer.disconnect();
			}
		};
	}, []);

	// useGSAP(() => {
	// 	const cards = gsap.utils.toArray(`.${styles.card}`);
	// 	cards.forEach((card: any, index: number) => {
	// 		gsap.to(card, {
	// 			opacity: 1,
	// 			y: 0,
	// 			duration: 0.4,
	// 			ease: "easeOut",
	// 			stagger: 0.2,
	// 			scrollTrigger: {
	// 				trigger: topSectionRef.current,
	// 				start: "top 10%",
	// 				toggleActions: "restart none reverse none",
	// 			},
	// 		});
	// 	});

	// 	if (topSectionRef.current) {
	// 		const cards = topSectionRef.current.querySelectorAll(`.${styles.card}`);
	// 		gsap.fromTo(
	// 			cards,
	// 			{
	// 				opacity: 0,
	// 				y: "50%",
	// 			},
	// 			{
	// 				opacity: 1,
	// 				y: 0,
	// 				duration: 0.5,
	// 				stagger: 0.2,
	// 				ease: "power2.out",
	// 				scrollTrigger: {
	// 					trigger: topSectionRef.current,
	// 					start: "top 10%",
	// 					toggleActions: "play none reverse none",
	// 				},
	// 			}
	// 		);
	// 	}
	// }, []);
	return {
		productData,
		topSectionRef,
		firstCardRef,
		secondCardRef,
		thirdCardRef,
		fourthCardRef,
	};
};

export default useFavourites;
